import {createSlice, type SliceSelectors} from '@reduxjs/toolkit'

import {ShoppingSubscriptionState, getInitialState} from '@web/slices/shoppingSubscription/slice'

import {MakeCreateSliceOptions, ShoppingSubscriptionReducers} from './interfaces'

export default (options?: MakeCreateSliceOptions) =>
    createSlice<
        ShoppingSubscriptionState,
        ShoppingSubscriptionReducers,
        'shoppingSubscription',
        SliceSelectors<ShoppingSubscriptionState>
    >({
        name: 'shoppingSubscription',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            options?.extraReducers?.(builder)
        },
    })
